import dayjs from 'dayjs'
import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useEspelhoPeriodoOutletContext } from 'pages/RelatorioEspelhoPeriodo.context'
import { useParams } from 'react-router-dom'
import { espelhoPeriodo } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirRelatorioEspelhoPeriodo() {
    const { id } = useParams()
    const { data } = useEspelhoPeriodoOutletContext()
    const item = data.find(item => item.id === id)

    const { mutateAsync, isLoading } = espelhoPeriodo.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!item || item.status === 'processando') return null

    const handleSubmit = () =>
        mutateAsync(item.id as any, {
            onSuccess: () => {
                toast.success('Relatório excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <ConfirmarExclusao
            permissao={['delete', 'EspelhoPontoPorPeríodo']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={
                <>
                    Realmente deseja excluir o relatório de{' '}
                    {dayjs.utc(item.createdAt).format('DD/MM/YYYY')}?
                </>
            }
        />
    )
}
